var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRoundedBlackSuccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "45px",
    height: "40px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "F9CDFA8B-FF1A-4C7F-8804-4C91C5CDF24C") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 500,
    height: 307,
    rx: 20
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "05---Defini\\xE7\\xF5es",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "MY-D-05-01-04-perfil-modal",
    transform: "translate(-704.000000, -136.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Overlay",
    fill: "none",
    opacity: 0,
    x: 0,
    y: 0,
    width: 1450,
    height: 1268
  }), /*#__PURE__*/React.createElement("g", {
    id: "Popup",
    transform: "translate(470.000000, 26.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Background-color",
    fill: "#FFFFFF",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(112.000000, 30.000000)",
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.000000, 80.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons/alert_time",
    transform: "translate(104.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16,0 C7.17995444,0 0,7.15981735 0,16 C0,24.8401826 7.17995444,32 16,32 C24.8200456,32 32,24.8401826 32,16 C32,7.15981735 24.8200456,0 16,0 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Line-Copy-3",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(16.005869, 15.425476) rotate(90.000000) translate(-16.005869, -15.425476) ",
    points: "15.4253633 20.9313455 20.4313455 16.2095872 11.5803935 9.91960651"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundedBlackSuccess);
export default __webpack_public_path__ + "static/media/rounded-black-success.ac844a3f664b909eb6861b436401d046.svg";
export { ForwardRef as ReactComponent };